/* Functions here is to handle everything about
 * drop down list value that not getting from API call
 */
import { SHARED, MONITOR_COUNTRY_CODES } from '@/constants'
import * as sessionHelper from './session.helper'
import { ACTIVATION_STATUS } from '@/constants/enums'
import i18n from '@/i18n'

export function getOptionAll(isStringVal = false) {
  return {
    title: i18n.t('label.all'),
    text: i18n.t('label.all'),
    value: isStringVal ? SHARED.DEFAULT_ALL_VALUE_STR : SHARED.DEFAULT_ALL_VALUE
  }
}

export function getActivationStatus(hasOptionAll, isBoolValue = false) {
  let ddl = []

  if (hasOptionAll) {
    ddl.push(getOptionAll())
  }

  ddl.push({
    text: i18n.t(`enumActivationStatus[0].${ACTIVATION_STATUS.ACTIVE}`),
    value: isBoolValue ? Boolean(ACTIVATION_STATUS.ACTIVE) : ACTIVATION_STATUS.ACTIVE
  })
  ddl.push({
    text: i18n.t(`enumActivationStatus[0].${ACTIVATION_STATUS.INACTIVE}`),
    value: isBoolValue ? Boolean(ACTIVATION_STATUS.INACTIVE) : ACTIVATION_STATUS.INACTIVE
  })

  return ddl
}

export function getWeekDays() {
  let ddl = []

  ddl.push({
    name: i18n.t(`enumWeekDay[0].1`),
    value: i18n.t(`enumWeekDay[0].1`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].2`),
    value: i18n.t(`enumWeekDay[0].2`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].3`),
    value: i18n.t(`enumWeekDay[0].3`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].4`),
    value: i18n.t(`enumWeekDay[0].4`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].5`),
    value: i18n.t(`enumWeekDay[0].5`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].6`),
    value: i18n.t(`enumWeekDay[0].6`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].7`),
    value: i18n.t(`enumWeekDay[0].7`),
  })

  return ddl
}

export function getAccountLockStatus(hasOptionAll, isBoolValue = false) {
  let ddl = []

  if (hasOptionAll) {
    ddl.push(getOptionAll())
  }

  ddl.push({
    text: i18n.t(`enumAccountLockStatus[0].${ACTIVATION_STATUS.ACTIVE}`),
    value: isBoolValue ? Boolean(ACTIVATION_STATUS.ACTIVE) : ACTIVATION_STATUS.ACTIVE
  })
  ddl.push({
    text: i18n.t(`enumAccountLockStatus[0].${ACTIVATION_STATUS.INACTIVE}`),
    value: isBoolValue ? Boolean(ACTIVATION_STATUS.INACTIVE) : ACTIVATION_STATUS.INACTIVE
  })

  return ddl
}

export function getLocationsFromLookups(locationsLookups) {
  return [
    {
      text: i18n.t('label.state'),
      value: SHARED.DEFAULT_ALL_VALUE_STR
    },
    ...locationsLookups.map((l) => {
      return {
        text: l.location,
        value: l.location
      }
    })
  ]
}

export function getLanguages() {
  let languages = [];

  languages.push({
    code: 'ms',
    name: i18n.t('languages.ms.name'), // Translated name for 'Bahasa Melayu'
    flag: '🇲🇾',
  });

  languages.push({
    code: 'en',
    name: i18n.t('languages.en.name'), // Translated name for 'English'
    flag: '🇺🇸',
  });

  languages.push({
    code: 'zh',
    name: i18n.t('languages.zh.name'), // Translated name for 'Chinese'
    flag: '🇨🇳',
  });

  languages.push({
    code: 'hi',
    name: i18n.t('languages.hi.name'), // Translated name for 'Hindi'
    flag: '🇮🇳',
  });

  return languages;
}

/* Country codes a domain / group can be created in.
 * `only` narrows the list (groups only exist for AU and MY); the result is
 * then cut down to the markets the signed-in user is allowed to see. */
export function getMonitorCountries(only = null) {
  return MONITOR_COUNTRY_CODES
    .filter((c) => !only || only.includes(c))
    .filter((c) => sessionHelper.canSeeCountry(c))
    .map((c) => ({ value: c, text: c }))
}

/* The full list, for the admin picking what a user may see. */
export function getAllMonitorCountries() {
  return MONITOR_COUNTRY_CODES.map((c) => ({ value: c, text: c }))
}

export function getCountries() {
  let countries = [];

  countries.push({
    value: 1,
    name: i18n.t('country.mly.name'), // Translated name for 'Bahasa Melayu'
    flag: '🇲🇾',
  });

  countries.push({
    value: 2,
    name: i18n.t('country.sg.name'), // Translated name for 'Singapore'
    flag: '🇸🇬',
  });

  return countries;
}

export function getAnswerTypes() {
  let types = [];

  types.push({
    code: 1,
    name: i18n.t('answerTypes.long.name'), // Translated name for 'Bahasa Melayu'
  });

  types.push({
    code: 2,
    name: i18n.t('answerTypes.short.name'), // Translated name for 'Bahasa Melayu'
  });

  types.push({
    code: 3,
    name: i18n.t('answerTypes.shortTextMarks.name'), // Translated name for 'Bahasa Melayu'
  });

  types.push({
    code: 0,
    name: i18n.t('answerTypes.option.name'), // Translated name for 'Bahasa Melayu'
  });

  return types;
}

export function getDiscountMethods() {
  let methods = [];

  // methods.push({
  //   code: 1,
  //   name: i18n.t('discountMethods.code.name'), // Translated name for 'Bahasa Melayu'
  // });
  methods.push({
    code: 2,
    name: i18n.t('discountMethods.value.name'), // Translated name for 'Bahasa Melayu'
  });
  methods.push({
    code: 3,
    name: i18n.t('discountMethods.percentage.name'), // Translated name for 'Bahasa Melayu'
  });


  return methods;
}

export function getPromotionType() {
  let methods = [];

  methods.push({
    code: 1,
    name: i18n.t('sendPromotionType.whatsapp.name'), // Translated name for 'Bahasa Melayu'
  });
  methods.push({
    code: 2,
    name: i18n.t('sendPromotionType.email.name'), // Translated name for 'Bahasa Melayu'
  });
  methods.push({
    code: 3,
    name: i18n.t('sendPromotionType.sms.name'), // Translated name for 'Bahasa Melayu'
  });

  return methods;
}

export function getShellLifeTime() {
  let times = [];

  times.push({
    code: i18n.t('shellLifeTime.n/a.name'),
    name: i18n.t('shellLifeTime.n/a.name'), // Translated name for 'Bahasa Melayu'
  });
  times.push({
    code: i18n.t('shellLifeTime.2.name'),
    name: i18n.t('shellLifeTime.2.name'), // Translated name for 'Bahasa Melayu'
  });
   times.push({
    code: i18n.t('shellLifeTime.5.name'),
    name: i18n.t('shellLifeTime.5.name'), // Translated name for 'Bahasa Melayu'
  });

  return times;
}
